import React, { Component } from 'react';
import { isChunkLoadError, tryReloadOnChunkError } from '../utils/chunkErrorUtils';

class ChunkErrorBoundary extends Component {
  componentDidCatch(error) {
    if (isChunkLoadError(error) && tryReloadOnChunkError(error)) {
      // Reload triggered
    }
  }

  render() {
    return this.props.children;
  }
}

export default ChunkErrorBoundary;
